import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React from 'react';
import { referralProgramHelpLink } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { ButtonLink } from 'reactApp/ui/ButtonLink/ButtonLink';

import styles from './ReferralInfo.css';

interface ReferralInfoProps {
    isMobile?: boolean;
}

export function ReferralInfo({ isMobile = false }: ReferralInfoProps) {
    return (
        <Text className={classNames(styles.root, { [styles.rootMobile]: isMobile })}>
            Копируя ссылку, вы&nbsp;соглашаетесь с&nbsp;
            <ButtonLink
                className={styles.link}
                primary
                size="medium"
                inline
                href={referralProgramHelpLink}
                target="_blank"
                fontInherit
                underline={false}
            >
                правилами программы
            </ButtonLink>
        </Text>
    );
}
